var ClickAndReserve;
(function(ClickAndReserve) {
    ClickAndReserve["STOCK"] = "STOCK";
    ClickAndReserve["STOCK_RESERVATION"] = "STOCK_RESERVATION";
    ClickAndReserve["STOCK_RESERVATION_APPOINTMENT"] = "STOCK_RESERVATION_APPOINTMENT";
})(ClickAndReserve || (ClickAndReserve = {}));

export { ClickAndReserve };
//# sourceMappingURL=feature-config.enum.js.map
